import MapsUgcOutlined from '@mui/icons-material/MapsUgcOutlined';
import MenuOpen from '@mui/icons-material/MenuOpen';
import UpdateDisabled from '@mui/icons-material/UpdateDisabled';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';
import React, { useEffect, useState } from 'react';
import MyContext from '../../Context/AppContext';
import { v4 as uuidv4 } from 'uuid';
import FetchChatHistory from '../../Apis/FetchChatHistory';
import { useNavigate } from 'react-router-dom'

const LeftDrawerChatPage = () => {
    const { openDrawer, setOpenDrawer, autoCloseDrawer, setAutoCloseDrawer, getRecentHistory, setJobDescriptionStatus, checkLimitExceed,
        handleNavigationAllow, userDetails } = React.useContext(MyContext);

    const [chatHistory, setChatHistory] = useState([]);
    const [chatHistoryPaginationData, setChatHistoryPaginationData] = useState({ page: 1, limit: 10 });
    const [totalCount, setTotalCount] = useState(0);
    const [chatHistoryLoading, setChatHistoryLoading] = useState(false);
    const navigate = useNavigate();

    const fetchChatHistoryData = async (behavior) => {
        try {
            setChatHistoryLoading(true);
            if (userDetails?.accountConfig?.permissions?.accessChatHistory === true) {
                let response = await FetchChatHistory({
                    userId: userDetails?._id,
                    pageSize: chatHistoryPaginationData.limit,
                    pageNumber: behavior === "init" ? 1 : chatHistoryPaginationData.page
                });
                if (response.status === 200) {
                    setTotalCount(response.data.response.totalCount);
                    setChatHistoryPaginationData({
                        ...chatHistoryPaginationData,
                        page: behavior === "init" ? 2 : chatHistoryPaginationData.page + 1
                    });
                    let recentChatHistoryData = response.data.response.data;
                    let chatHistoryArray = behavior === "init" ? [] : [...chatHistory];
                    let updatedChatHistoryArr = convertChatHistory(recentChatHistoryData);
                    chatHistoryArray = [...chatHistoryArray, ...updatedChatHistoryArr];
                    setChatHistory(chatHistoryArray);
                }
            }
        } catch (error) {
            console.log("error", error);
        }
        finally {
            setChatHistoryLoading(false);
        }
    };

    useEffect(() => {
        fetchChatHistoryData("init");
    }, [getRecentHistory]);


    const convertChatHistory = (chatHistoryArr) => {
        let updatedChatHistoryArr = [];

        chatHistoryArr.forEach(element => {
            let chatHistoryArr = element.history;
            let chatInfo = {
                id: element._id,
                sessionid: element.sessionid,
                userId: element.userid,
            };
            let obj = {
                title: element?.title,
                description: chatHistoryArr[1].message.length > 70 ? chatHistoryArr[1].message.substring(0, 68) + '...' : chatHistoryArr[1].message,
                chatInfo: chatInfo
            };
            updatedChatHistoryArr.push(obj);
        });
        return updatedChatHistoryArr;
    }

    const goToRecentChat = (chatId) => {

        let navigationAllow = handleNavigationAllow();
        if (navigationAllow) {

            let chatHistoryOld = [...chatHistory];
            const selectedChat = chatHistoryOld.find(chat => chat?.chatInfo?.sessionid === chatId);

            const filteredChats = chatHistoryOld.filter(chat => chat?.chatInfo?.sessionid !== chatId);

            const updatedChatHistory = [selectedChat, ...filteredChats];

            setChatHistory(updatedChatHistory);

            navigate(`/app/chat/${chatId}`);

            if (autoCloseDrawer) {
                setAutoCloseDrawer(false);
                setOpenDrawer(!openDrawer);
            }
        }
    };

    const goToNewChat = async () => {
        let navigationAllow = handleNavigationAllow();
        if (navigationAllow) {
            setJobDescriptionStatus({
                isContinueChat: false,
                isEmailSent: false,
            });

            let limitExceedStatus = checkLimitExceed()
            let createJdAccess = userDetails?.accountConfig?.permissions?.createJd
            if (limitExceedStatus || createJdAccess === false) {
                navigate('/app/limitExceeded')
            }
            else {
                let uuid = uuidv4()
                navigate(`/app/chat/${uuid}`);
            }
        }
    }


    return (
        <>
            <Drawer variant='persistent' open={openDrawer}>
                <div className='drawerMainContainer'>
                    <IconButton onClick={() => setOpenDrawer(!openDrawer)} className='iconButtons_DefaultMenu'>
                        <MenuOpen />
                    </IconButton>
                    <Button className='newMessageButton' startIcon={<MapsUgcOutlined />} onClick={() => goToNewChat()}>
                        New Chat
                    </Button>

                    <div className='chatHistoryContentContainer'>
                        <span className='recentTitle'>Recent Job Descriptions</span>
                        {userDetails?.accountConfig?.permissions?.accessChatHistory === false ? <div className='chatHistoryAccessDeniedContainer'>
                            <UpdateDisabled />
                            <span>You don't have any permissions for accessing the old created Jobdescriptions !</span>
                        </div> :
                            <div
                                className='chatHistoryContainer'
                                onScroll={(e) => {
                                    const bottomThreshold = 50;
                                    const { scrollTop, clientHeight, scrollHeight } = e.target;

                                    if (scrollHeight - scrollTop - clientHeight < bottomThreshold) {
                                        if (totalCount > chatHistory.length && !chatHistoryLoading)
                                            fetchChatHistoryData("scroll");
                                    }
                                }}
                            >
                                {
                                    chatHistory.map((chat, index) => (
                                        <div key={index} className={index === 0 ? 'chatHistoryItem_current' : 'chatHistoryItem'} onClick={() => goToRecentChat(chat?.chatInfo?.sessionid)}>
                                            <span className='chatHistoryTitle'>{chat.title}</span>
                                            <span className='chatHistoryDecription'>{chat.description}</span>
                                        </div>
                                    ))
                                }

                                {chatHistoryLoading ? Array.from({ length: 5 }).map((_, index) => (
                                    <div key={index} className='chatHistoryItem_skeleton'>
                                        <Skeleton variant="rectangular" width={251} height={80} className="skeleton_chatHistory" />
                                    </div>
                                )) : null}
                            </div>
                        }
                    </div>
                </div>
            </Drawer>
        </>
    );
};

export default LeftDrawerChatPage;
